import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import styled from "styled-components";

import PartnersProductsTool from "../partners/tools/PartnersProductsTool";

// import n_img from "../partners/tools/st_int.jpg";
import n_img from "../partners/tools/st_im_5.jpg";
import TripsPanel from "../trips/TripsPanel";
import { TopAb2 } from "./science-labs-page";

const InternationalPage = () => {
    const { t, i18n } = useTranslation();
    let isRu = i18n.language == "ru";

    const [bigUrl, setBigUrl] = useState(undefined);

    return (
        <OuterWrapper className={"about_page"}>
            <TopAb2 style={{
                backgroundImage: `url(${n_img})`
            }}>
                {isRu ? 'Международные программы' : 'International programs'}
            </TopAb2>

            <Wrapper style={{paddingTop: 60}} >
                {/*<TopImg src={n_img} />*/}

                {/*<TopPlaceholder>*/}
                {/*    /!*<SupTopPlaceholder>*!/*/}
                {/*    /!*    <BackLink href={"/"}></BackLink>*!/*/}
                {/*    /!*</SupTopPlaceholder>*!/*/}
                {/*    <Heading>*/}
                {/*        Международные программы*/}
                {/*    </Heading>*/}
                {/*</TopPlaceholder>*/}

                {/*<PartnersProductsTool*/}

                {/*/>*/}


                <TripsPanel
                    mode={'view'}
                    type={'international'}
                    isInternational={true}
                />

            </Wrapper>

        </OuterWrapper>
    );
};

const TopImg = styled.img`
  display: block;
  width: 100%;
  @media (max-width: 820px) {
    display: none;
  }
`;

const GlobalWarningPlaceholder = styled.div`
  position: fixed;
  z-index: 100;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const WhiteBox = styled.div`
  padding: 20px;
  border-radius: 8px;
  text-align: justify;
  background: white;
  width: 620px;
  box-sizing: border-box;
  @media (max-width: 620px) {
    width: calc(100vw - 40px);
    padding: 10px;
  }
`;

const WarningButtonPlaceholder = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LoImg = styled.div`
  width: 240px;
  height: 240px;
  box-sizing: border-box;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(${(props) => props.src});
  margin: 10px;
  cursor: pointer;
`;

const Ul = styled.ul`
  box-sizing: border-box;
  padding-left: 15px;
  margin-bottom: 25px;
`;

const Li = styled.li`
  margin-bottom: 10px;
  box-sizing: border-box;
`;

const Heading2 = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 27px;
  color: #212121;
`;

const BLabel = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #212529;
`;

const DownImg = styled.img`
  height: 24px;
  cursor: pointer;
`;

const FileItemHeading = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  color: #212529;
`;

const FileItemSubHeading = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  color: #aaaaaa;
`;

const RightContentPlaceholder = styled.div``;

const MyP = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  color: #212529;
  margin-bottom: 15px;
`;

const FileItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
  cursor: pointer;
`;

const FileItemContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const FileItemLeft = styled.div`
  flex: 1;
`;

const FileItemRight = styled.div``;

const FileImg = styled.img`
  height: 40px;
  margin-right: 8px;
`;

const RightHeading = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 27px;
  font-family: "Noto Sans", sans-serif;
  margin-bottom: 20px;
`;

const Left = styled.div`
  flex: 1;
  @media (max-width: 800px) {
    margin-left: 0px;
    padding: 5px;
  }
`;

const Right = styled.div`
  width: 380px;
  margin-left: 40px;
  @media (max-width: 800px) {
    margin-left: 0px;
    padding: 5px;
  }
`;

const RightBox = styled.div`
  background: #f4f9fc;
  border-radius: 12px;
  box-sizing: border-box;
  padding: 32px;
  margin-bottom: 32px;
  @media (max-width: 800px) {
    padding: 20px;
  }
`;

const ContentPlaceholder = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  @media (max-width: 800px) {
    display: block;
  }
`;

const BackLink = styled.a`
  text-decoration: none;
  color: ${({ theme }) => theme.grey};
  cursor: pointer;
`;

const OuterWrapper = styled.div`
  width: 100%;
  background: white;
  padding-top: 30px;
  box-sizing: border-box;
  padding-bottom: 40px;
`;

const Wrapper = styled.div`
  text-align: left;
  box-sizing: border-box;
  width: 1400px;
  margin: 0 auto;
  padding: 15px;
  @media (max-width: 1400px) {
    width: 100%;
  }
`;

const Heading = styled.div`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 56px;
  line-height: 72px;
  margin-bottom: 40px;
  @media (max-width: 820px) {
    font-size: 24px;
    line-height: 32px;
    padding-left: 5px;
  }
`;

const SupTopPlaceholder = styled.div`
  margin-bottom: 20px;
`;

const TopPlaceholder = styled.div``;

export default InternationalPage;
